var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        title: "ESCOLHA UM NOME E CADASTRE",
        subtitle: "Escolha um nome para o seu endereço e cadastre-o.",
        size: "md"
      }
    },
    [
      _c("template", { slot: "body" }, [
        _c("div", { staticClass: "options" }, [
          _c(
            "div",
            {
              class: { active: _vm.name === "Casa" },
              on: { click: _vm.optionSelected }
            },
            [_vm._v("\n        Casa\n      ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: { active: _vm.name === "Apartamento" },
              on: { click: _vm.optionSelected }
            },
            [_vm._v("\n        Apartamento\n      ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: { active: _vm.name === "Trabalho" },
              on: { click: _vm.optionSelected }
            },
            [_vm._v("\n        Trabalho\n      ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: { active: _vm.name === "Casa dos Pais" },
              on: { click: _vm.optionSelected }
            },
            [_vm._v("\n        Casa dos Pais\n      ")]
          )
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|min:2|max:255",
              expression: "'required|min:2|max:255'"
            },
            {
              name: "model",
              rawName: "v-model",
              value: _vm.name,
              expression: "name"
            }
          ],
          staticClass: "mt-10",
          attrs: {
            type: "text",
            name: "nome",
            placeholder: "escolha uma das opções acima ou digite um nome aqui"
          },
          domProps: { value: _vm.name },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.name = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _vm.error
          ? _c("div", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          {
            staticClass: "btn bg-gray",
            on: {
              click: function($event) {
                return _vm.$emit("prev")
              }
            }
          },
          [_vm._v("voltar")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "btn bg-purple",
            class: { "btn--loading": _vm.loader },
            on: {
              click: function($event) {
                return _vm.confirm()
              }
            }
          },
          [_c("span", [_vm._v("confirmar e criar")])]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e9ae709", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e9ae709","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Addresses/NewAddress/SetNameAndCreate.vue
// module id = null
// module chunks = 